// Hilfsfunktionen zur Erzeugung der nächsten Rechnungsnummer
// Regeln:
// - Wenn vorherige Nummer existiert: letztes zusammenhängendes Ziffernsegment wird inkrementiert (mit Padding beibehalten)
// - Wenn die Nummer mit "YYYY-" beginnt und das Jahr sich geändert hat, wird zurückgesetzt auf CURRENTYEAR-0001
// - Fallback, wenn keine vorige Nummer: CURRENTYEAR-0001

export function generateNextInvoiceNumber(prev?: string, now: Date = new Date()): string {
  const year = now.getFullYear();
  if (!prev || !prev.trim()) {
    return `${year}-0001`;
  }
  const trimmed = prev.trim();
  // Jahrwechsel-Reset
  const yearPrefixMatch = /^(\d{4})[-_]/.exec(trimmed);
  if (yearPrefixMatch && Number(yearPrefixMatch[1]) !== year) {
    return `${year}-0001`;
  }
  // Letztes Ziffernsegment suchen
  // matchAll wird durch explizite exec-Schleife ersetzt (ES5-kompatibel)
  const digitRegex = /(\d+)/g;
  const segments: RegExpExecArray[] = [];
  let m: RegExpExecArray | null;
  while ((m = digitRegex.exec(trimmed)) !== null) {
    segments.push(m);
  }
  if (segments.length === 0) {
    return `${year}-0001`;
  }
  const last = segments[segments.length - 1];
  const digits = last[1];
  const startIdx = last.index ?? trimmed.length - digits.length;
  const num = parseInt(digits, 10);
  const nextNum = (num + 1).toString().padStart(digits.length, '0');
  return trimmed.slice(0, startIdx) + nextNum + trimmed.slice(startIdx + digits.length);
}
